import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import AddonServices from "services/AddonServices";
import { notifyError, notifySuccess } from "utils/toast";

const useAddonSubmit = (id) => {
  
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCity, setSelectedCity] = useState();
  const [serviceType, setServiceType] = useState(null);
  const {
    trigger,
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const cityIds = selectedCity?.map((state) => {
      if (typeof state === 'string') {
        return state; 
      }
      if (typeof state === 'object' && state.value) {
        return state.value;
      }
      return null;
    }).filter(Boolean); 

    
     if(!cityIds || cityIds.length < 1){
            notifyError("City is required");
            return;
          }
    setLoading(true);
    try {
      setIsSubmitting(true);

      const AddonTypeData = {
        name: data.name,
        price: data.price,
        description: data.description,
        tax: data.tax,
        city: cityIds,
        service_type: serviceType,
      };

      if (id) {
        const res = await AddonServices.updateAddonType(id, AddonTypeData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await AddonServices.addAddonType(AddonTypeData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getAddonData = async () => {
    try {
      const res = await AddonServices.getAddonTypeById(id);
      if (res) {
        setValue("name", res.name);
        setValue("price", res.price);
        setValue("tax", res.tax);
        setValue("description", res.description);
        setSelectedCity(res.city);
        setServiceType(res.service_type);
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setValue("name");
      setValue("description");
      setValue("price");
      setValue("tax");
      setServiceType();
      setSelectedCity();
      clearErrors();
      return;
    }
      
    if (id) {
        getAddonData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    loading,setLoading,
    errors,
    isSubmitting,
    selectedCity, setSelectedCity,
    setServiceType,
		serviceType,
  };
};

export default useAddonSubmit;
